/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { pageApi } from '../../api/page.api';
import { ITableApiListQuery } from '../../modules/table/api/types';
import {
    CampaignsTableAccountInitialise,
    CampaignsTableSubscriberInitialise,
} from './components/Table/CampaignsTableInitialise';

export const campaignsApi = pageApi.injectEndpoints({
    endpoints: (builder => ({
        getAccountCount: builder.query<number, Omit<ITableApiListQuery, 'url'>>({
            query: ({ from, size }) => `${CampaignsTableAccountInitialise.list?.url}?from=${from || 0}&size=${size}`,
            transformResponse: ({ count }) => count,
        }),
        getSubscriberCount: builder.query<number, Omit<ITableApiListQuery, 'url'>>({
            query: ({ from, size }) => `${CampaignsTableSubscriberInitialise.list?.url}?from=${from || 0}&size=${size}`,
            transformResponse: ({ count }) => count,
        }),
        getAccountTotalCount: builder.query<number, void>({
            query: () => `${CampaignsTableAccountInitialise.totalCount?.url}`,
            transformResponse: ({ totalCount }) => totalCount,
        }),
        getSubscriberTotalCount: builder.query<number, void>({
            query: () => `${CampaignsTableSubscriberInitialise.totalCount?.url}`,
            transformResponse: ({ totalCount }) => totalCount,
        }),
    })),
});

export const {
    useLazyGetAccountCountQuery,
    useLazyGetSubscriberCountQuery,
    useLazyGetAccountTotalCountQuery,
    useLazyGetSubscriberTotalCountQuery,
} = campaignsApi;
